import { Observable } from 'rxjs';
import { Component, Input, inject } from '@angular/core';
import { Project, ProjectMeta } from '../../projects/project.model';
import { ProjectSettingsContext } from '../project-settings.context';
import { TenantHelper } from '../../common/helpers/tenant.helper';
import { ModalNotificationService } from '../../notification/modal-notification.service';

@Component({
    selector: 'adm4-project-settings-details',
    template: `
    <div class='full-height-flex'>
      <div class='remaining-space-flex-content-wrapper'>
        <div class='details-container remaining-space-flex-content'>
          @if (!!(project$ | async)) {
            <adm4-project-information
              [project]='project$ | async'
              [projectMeta]='projectMeta$ | async'
              [hasProjectModifyAccess]="hasProjectModifyAccess$ | async"
              (deleteProject)="triggerDeleteProject()"
            ></adm4-project-information>
          }
          <adm4-project-dependencies
            [readOnly]="isCurrentProjectReadonly$ | async"
          [projectKey]="projectKey"></adm4-project-dependencies>
          <adm4-project-permissions
            [readOnly]="!(hasAdminAccess$ | async)"
          [projectKey]="projectKey"></adm4-project-permissions>
          <div>
          </div>
        </div>
      </div>
    </div>
    `,
    styleUrls: ['../../common/styles/component-specific/settings-details.scss'],
    standalone: false
})
export class ProjectSettingsDetailsComponent {
  projectSettingsContext = inject(ProjectSettingsContext);
  private modalNotificationService = inject(ModalNotificationService);

  @Input() projectKey: string;

  project$: Observable<Project | undefined>;
  projectMeta$: Observable<ProjectMeta | null>;
  hasAdminAccess$: Observable<boolean>;
  hasProjectModifyAccess$: Observable<boolean>;
  isCurrentProjectReadonly$: Observable<boolean>;


  constructor() {
    const projectSettingsContext = this.projectSettingsContext;

    this.project$ = this.projectSettingsContext.currentProject$;
    this.projectMeta$ = this.projectSettingsContext.projectMeta$;
    this.hasAdminAccess$ = projectSettingsContext.hasAdminAccess$;
    this.hasProjectModifyAccess$ = projectSettingsContext.hasProjectModifyAccess$;
    this.isCurrentProjectReadonly$ = projectSettingsContext.isCurrentProjectReadonly$;
  }

  triggerDeleteProject() {
    const projectName = TenantHelper.cropTenantFromKey(this.projectKey);
    this.modalNotificationService.openConfirmDialog({
      headerTitle: `Warning`,
      title: `Delete ${projectName}`,
      description: `You are deleting the "${projectName}" project. The deletion is irreversible. It can't be undone. Project data published to GIT will not be deleted.`
    }, {
      confirmButtonText: 'Delete'
    }).afterClosed().subscribe((confirmed?: boolean) => {
      if (confirmed === true) {
        this.projectSettingsContext.deleteProject(this.projectKey);
      }
    });
  }

}
